/**
 * Query keys for financial data (bank accounts, monthly fees, and current month lists).
 * Kept outside the query hook modules so tests can use the real keys while those hooks are mocked.
 */
export const financialQueryKeys = {
  bankAccounts: (terreiroId: string | undefined) =>
    ["terreiro", terreiroId, "bank-accounts"] as const,
  mediumBankAccounts: (mediumId: string | undefined) =>
    ["medium", mediumId, "bank-accounts"] as const,
  monthlyFees: (terreiroId: string | undefined) =>
    ["terreiro", terreiroId, "monthly-fees"] as const,
  currentMonthOutcome: (
    terreiroId: string | undefined,
    mediumId: string | undefined,
    month?: number,
    year?: number,
  ) => {
    const periodPart =
      month !== undefined && year !== undefined ? ([month, year] as const) : [];

    return terreiroId
      ? ([
          "outcome",
          "current-month",
          "terreiro",
          terreiroId,
          ...periodPart,
        ] as const)
      : ([
          "outcome",
          "current-month",
          "medium",
          mediumId,
          ...periodPart,
        ] as const);
  },
  currentMonthIncome: (
    terreiroId: string | undefined,
    mediumId: string | undefined,
    month?: number,
    year?: number,
  ) => {
    const periodPart =
      month !== undefined && year !== undefined ? ([month, year] as const) : [];

    return terreiroId
      ? ([
          "income",
          "current-month",
          "terreiro",
          terreiroId,
          ...periodPart,
        ] as const)
      : ([
          "income",
          "current-month",
          "medium",
          mediumId,
          ...periodPart,
        ] as const);
  },
};

/**
 * Query key for financial overview.
 * Omitting month/year yields the prefix shared by every period of that owner.
 */
export const financialOverviewQueryKey = (scope: {
  terreiroId?: string;
  mediumId?: string;
  month?: number;
  year?: number;
}) => {
  const periodPart =
    scope.month !== undefined && scope.year !== undefined
      ? ([scope.month, scope.year] as const)
      : [];

  if (scope.terreiroId) {
    return [
      "terreiro",
      scope.terreiroId,
      "financial-overview",
      ...periodPart,
    ] as const;
  }

  if (scope.mediumId) {
    return [
      "medium",
      scope.mediumId,
      "financial-overview",
      ...periodPart,
    ] as const;
  }

  return ["financial-overview", "no-scope", ...periodPart] as const;
};
